import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpService } from '../http.service';
@Component({
  selector: 'app-swinkpay-success',
  templateUrl: './swinkpay-success.component.html',
  styleUrls: ['./swinkpay-success.component.scss'],
})
export class SwinkpaySuccessComponent implements OnInit, OnDestroy {
  message: string = '';
  chegUrl: string = '';
  deviceType: string = '';
  paymentType: any;
  orderId: any;
  bankName: any;
  refNo: any;
  razorpayid: any;
  constructor(private httpService: HttpService) {
    this.message = 'Payment Success';
    this.deviceType = this.httpService.getLocalStorage('DeviceType');
    this.chegUrl = this.httpService.getLocalStorage('ChegUrl');
    this.paymentType = this.httpService.getLocalStorage('PaymentType');
    this.refNo = this.httpService.getLocalStorage('refNo');
    this.razorpayid = this.httpService.getLocalStorage('razorpayid');
    this.bankName = this.httpService.getLocalStorage('bankName');
    this.insertLogs(
      this.deviceType +
        ' this.deviceType' +
        ' this.chegUrl ' +
        this.chegUrl +
        'this.message ' +
        this.message +
        'this.bankName ' +
        this.bankName
    );
    if (this.paymentType == 'razorpay') {
      this.postPaymentDetails();
    }
    if (this.deviceType == 'web') {
      setTimeout(() => {
        window.open(this.chegUrl, '_self');
      }, 5000);
    }

    console.log('message', this.message);
  }
  ngOnDestroy(): void {
    console.log('SwinkpaySuccessComponent is being destroyed.');
    localStorage.clear();
  }

  ngOnInit(): void {}
  async insertLogs(url: any) {
    let data = {
      moduleName: 'success',
      url: url,
    };
    let result = this.httpService.insertLogs(data);
  }
  async postPaymentDetails() {
    this.orderId = this.httpService.getLocalStorage('orderId');
    let model: any;
    model = {
      bankName: this.bankName,
      order_id: this.refNo,
      razorpay_payment_id: this.razorpayid,
      paymentType: 'razorpay',
    };

    let result = await this.httpService.postRazorPaymentDetails(model);

    if (result) {
      this.httpService.setLocalStorage('ChegUrl', result.chegUrl);
      this.insertLogs(
        'ChegUrl ' + result.chegUrl + 'Message ' + result.message
      );
      // if (result.status == 'COMPLETE') {
      //   this.router.navigate(['/success']);

      // } else if (result.status == 'Payment failed') {
      //   this.httpService.setLocalStorage('Message', result.message);
      //   console.log("2", result);
      //   this.router.navigate(['/payment-failure']);
      // } else if (result.status == 'payment progress') {
      //   this.message = result.message;
      //   this.httpService.setLocalStorage('Message', result.message);
      //   this.router.navigate(['/payment-pending']);
      //   // alert(result.message);//closable popup
      // } else if (result.status == 'failed') {
      //   this.httpService.setLocalStorage('Message', result.message);
      //   this.router.navigate(['/failure']);
      // } else if (result.status == 'invalid') {
      //   this.httpService.setLocalStorage('Message', result.message);
      //   this.router.navigate(['/failure']);
      // } else if (result.status == 'Invalid Amount') {
      //   this.httpService.setLocalStorage('Message', result.message);
      //   this.router.navigate(['/failure']);
      // } else if (result.status == 'PROCESSING') {
      //   this.httpService.setLocalStorage('Message', result.message);
      //   this.router.navigate(['/success']);
      // }

      let status = result.status.toLowerCase();
      this.message = result.message;
      this.insertLogs(
        'ChegUrl ' +
          result.chegUrl +
          'Message ' +
          result.message +
          'status ' +
          status
      );
    }
  }
}
